module.exports = __webpack_public_path__ + "media/BEFIRST_moment02.e4a89fc9.mp4";